<template>
	<div>
		<div class="d-flex flex-row mb-4">
			<h1>Call Center</h1>
		</div>

		<div class="d-flex flex-row-reverse mb-4">
			<b-btn @click="goToNewCall" class="cursor-pointer" variant="primary">Nueva llamada</b-btn>
		</div>

		<template v-if="calls && calls.length > 0">

			<div class="flex flex-row mb-4 orders-footer">
				<small>
					Llamadas filtradas: <strong>{{this.itemsToRender.length}}</strong>
				</small>
			</div>

			<div class="d-flex flex-row mb-4">
				<b-form-input v-model="textFilterInputValue" placeholder="Escribe para filtrar" class="mr-2"/>
				<b-form-select v-model="schoolFilter" :options="schoolsDropdown" class="mr-2">
					<template slot="first">
						<option :value="null">Todos los colegios</option>
					</template>
				</b-form-select>
				<b-form-select v-model="reasonFilter" :options="reasonsDropdown" class="mr-2">
					<template slot="first">
						<option :value="null">Todos los temas</option>
					</template>
				</b-form-select>
				<b-form-select v-model="callerTypeFilter" :options="callerTypesDropdown">
					<template slot="first">
						<option :value="null">Todos los tipos de cliente</option>
					</template>
				</b-form-select>
			</div>

			<b-table bordered hover :items="itemsToRender" class="cursor-pointer" :fields="tableFields" :per-page="10" :current-page="currentPage" @row-clicked="onRowClick">
				<template slot="hour" slot-scope="item">
					{{getHumanTime(item.value)}}
				</template>
				<template slot="callDurationSeconds" slot-scope="item">
					{{getHumanTimeBySeconds(item.value)}}
				</template>
				<template slot="createdAt" slot-scope="item">
					{{getHumanDate(item.value)}}
				</template>
			</b-table>

			<b-pagination size="md" :total-rows="itemsToRender.length" :per-page="10" v-model="currentPage" />

		</template>
		<template v-else-if="calls">
			No hay llamadas
		</template>
		<template v-else-if="!calls">
			Cargando llamadas...
			<img src="../../assets/spinner.gif" alt="">
		</template>
	</div>
</template>

<script>

export default {
	timeoutFilter: null,
	data () {
		return {
			tableFields: {
				id: {
					label: 'Id',
					sortable: true
				},
				hour: {
					label: 'Hora',
					sortable: true
				},
				callDurationSeconds: {
					label: 'Duración',
					sortable: true
				},
				schoolName: {
					label: 'Colegio',
					sortable: true
				},
				reasonName: {
					label: 'Tema',
					sortable: true
				},
				callerTypeName: {
					label: 'Tipo de cliente',
					sortable: true
				},
				agent: {
					label: 'Agente',
					sortable: true
				},
				createdAt: {
					label: 'Fecha',
					sortable: true
				}
			},
			textFilterInputValue: '',
			textFilterQuery: '',
			schoolFilter: null,
			reasonFilter: null,
			callerTypeFilter: null,
			currentPage: 0
		};
	},
	watch: {
		textFilterInputValue () {
			clearTimeout(this.timeoutFilter);

			if (this.textFilterInputValue === '' || this.textFilterInputValue.length < 3) {
				this.textFilterQuery = '';
				return;
			}

			this.timeoutFilter = setTimeout(() => {
				this.textFilterQuery = this.textFilterInputValue;
			}, 750);
		}
	},
	computed: {
		calls () {
			return this.$store.state.calls.calls.map((call) => {
				call.hour = call.createdAt;
				call.humanDate = this.getHumanDate(call.createdAt);
				call.schoolName = call.school.name;
				call.reasonName = call.reason.name;
				call.callerTypeName = call.callerType.name;
				call.agent = call.user.username;
				return call;
			});
		},
		itemsToRender () {
			if (!this.calls) return [];

			return this.calls.filter((item) => {

				let match = true;

				if (this.textFilterQuery) match = JSON.stringify(item).toLowerCase().includes(this.textFilterQuery.toLowerCase());

				if (match && this.schoolFilter !== null) {
					match = item.schoolId == this.schoolFilter;
				}

				if (match && this.reasonFilter !== null) {
					match = item.reasonId == this.reasonFilter;
				}

				if (match && this.callerTypeFilter !== null) {
					match = item.callerTypeId == this.callerTypeFilter;
				}

				return match;
			});
		},
		schoolsDropdown () {
			return this.$store.state.dropdowns.schoolsDropdown;
		},
		reasonsDropdown () {
			return this.$store.state.dropdowns.reasonsDropdown;
		},
		callerTypesDropdown () {
			return this.$store.state.dropdowns.callerTypesDropdown;
		}
	},
	methods: {
		goToNewCall () {
			this.$router.push('/calls/new');
		},
		getHumanTimeBySeconds (time) {
			let hours = Math.floor(time / 3600);
			let minutes = Math.floor((time % 3600) / 60);
			let seconds = time % 60;
			if (minutes == 0) return `${seconds}s`;
			if (hours == 0) return `${minutes}m`;
			return `${hours}h+`;
		},
		getHumanTime (date) {
			if (typeof date === 'string' || typeof date === 'number') date = new Date(date);
			let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
			let month = (date.getMonth() + 1) < 10 ? `0${(date.getMonth() + 1)}` : (date.getMonth() + 1);
			let hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
			let minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
			let seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
			return hours + ':' + minutes;
		},
		getHumanDate (date) {
			if (typeof date === 'string' || typeof date === 'number') date = new Date(date);
			let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
			let month = (date.getMonth() + 1) < 10 ? `0${(date.getMonth() + 1)}` : (date.getMonth() + 1);
			return day + '/' + month + '/' + date.getFullYear();
		},
		onRowClick (item, index, e) {
			if (e.metaKey || e.ctrlKey) window.open(`/calls/${item.id}`, '_blank');
			else this.$router.push('/calls/' + item.id);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/calls/List.vue